import { OptionalStringField } from '@src/permitField/PermitFields';

export class PermitInstructionsField extends OptionalStringField {
  public static fieldName: string = 'instructions' as const;
}
